module.exports = __webpack_public_path__ + "static/media/class_job_005.fbb497ac.svg";